// Utility functions for time and opening hours

export const isOpenNow = (hours) => {
  const now = new Date();
  const dayNames = ['dimanche', 'lundi', 'mardi', 'mercredi', 'jeudi', 'vendredi', 'samedi'];
  const currentDay = dayNames[now.getDay()];
  const currentTime = now.getHours() * 60 + now.getMinutes();

  const todayHours = hours[currentDay];
  if (!todayHours) return false;

  for (const period of todayHours) {
    const [openHour, openMin] = period.open.split(':').map(Number);
    const [closeHour, closeMin] = period.close.split(':').map(Number);
    
    const openTime = openHour * 60 + openMin;
    let closeTime = closeHour * 60 + closeMin;
    
    // Handle midnight closing (00:00)
    if (closeTime === 0) closeTime = 24 * 60;
    
    if (currentTime >= openTime && currentTime <= closeTime) {
      return true;
    }
  }
  
  return false;
};

export const getNextOpeningTime = (hours) => {
  const now = new Date();
  const dayNames = ['dimanche', 'lundi', 'mardi', 'mercredi', 'jeudi', 'vendredi', 'samedi'];
  const currentDay = dayNames[now.getDay()];
  const currentTime = now.getHours() * 60 + now.getMinutes();

  // Check today's remaining periods
  const todayHours = hours[currentDay];
  if (todayHours) {
    for (const period of todayHours) {
      const [openHour, openMin] = period.open.split(':').map(Number);
      const openTime = openHour * 60 + openMin;
      
      if (currentTime < openTime) {
        return `Ouvre à ${period.open}`;
      }
    }
  }

  // Check next days
  for (let i = 1; i <= 7; i++) {
    const nextDayIndex = (now.getDay() + i) % 7;
    const nextDay = dayNames[nextDayIndex];
    const nextDayHours = hours[nextDay];
    
    if (nextDayHours && nextDayHours.length > 0) {
      const dayName = nextDay.charAt(0).toUpperCase() + nextDay.slice(1);
      return `Ouvre ${dayName} à ${nextDayHours[0].open}`;
    }
  }

  return 'Horaires non disponibles';
};

export const formatHours = (dayHours) => {
  if (!dayHours || dayHours.length === 0) return 'Fermé';
  
  return dayHours
    .map(period => `${period.open} - ${period.close}`)
    .join(' et ');
};
